import { connect } from "react-redux";
import styles from "./index.module.css";
import icon from "../../../assets/icons/navbar/sessions@4x.png";
import {
  closeLoading,
  openLoading,
} from "../../../components/loadingModal/loading";
import alert from "../../../components/AlertModal/alertModal";
import { useEffect, useState, useCallback } from "react";
import { getSession } from "../../../actions/manageSessionsAction";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Table from "./users_table";
import ArrowGoBack from "../../../components/ArrowGoBack/ArrowGoBack";

const PastSessionPage = (props) => {
  const { getSession } = props;
  const { idSession } = useParams();
  const navigate = useNavigate();

  const initialState = {
    title: "",
    module: {},
    course: {},
    date: "",
    time: "",
    users: [],
  };

  const [state, setState] = useState(initialState);

  // Usar useCallback para memoizar la función
  const getInitialData = useCallback(async () => {
    openLoading();
    try {
      const response = await getSession(idSession);
      const date = moment(response.dateSession.split("T")[0]).format(
        "MMM DD, YYYY",
      );
      const time = moment(response.dateSession).format("h:mm A");
      setState({ ...response, date, time });
    } catch (error) {
      alert("error", error.message);
    } finally {
      closeLoading();
    }
  }, [idSession, getSession]);

  useEffect(() => {
    getInitialData();

    // Limpieza optimizada
    return () => {
      setState(initialState);
    };
  }, [getInitialData]);

  // Manejar navegación de forma no bloqueante
  const handleClose = useCallback(() => {
    // Usar setTimeout para liberar el hilo principal
    setTimeout(() => navigate(-1), 0);
  }, [navigate]);

  return (
    <div className="box-container">
      <ArrowGoBack />
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.headerContainer}>
            {/* Cambiar aquí */}
            <button className="close" onClick={handleClose} />
            <img src={icon} alt="session icon" />
            <span>{state.title}</span>
            <div className={styles.textGroup}>
              <div>
                <div>MODULE</div>
                <div>{state.module.name}</div>
              </div>
              <div>
                <div>COURSE</div>
                <div>
                  {state.course
                    ? state.course.name
                    : "there not associated courses"}
                </div>
              </div>
              <div>
                <div>ROOM NUMBER</div>
                <div>{state.sessionCode}</div>
              </div>
            </div>
            <div className={styles.textGroup}>
              <div>
                <div>DATE</div>
                <div>{state.date}</div>
              </div>
              <div>
                <div>START TIME</div>
                <div>{state.time}</div>
              </div>
            </div>
          </div>
          <div className="table-container">
            <Table users={state.users} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { getSession })(PastSessionPage);
